export default {"src":"/_next/static/media/banner-sharmila.df98f176.svg","height":48,"width":291,"blurWidth":0,"blurHeight":0};